export const TRACES_SAMPLE_RATE = 1;
